import request from "../utils/request";

export async function getAllKitchen() {
  return request.get("Kitchen");
}

export async function addKitchen(kitchen) {
  return request.post("Kitchen", kitchen);
}

export async function updateKitchen(kitchen) {
  return request.put("Kitchen", kitchen);
}

export async function deleteKitchen(id) {
  return request.delete(`Kitchen/${id}`);
}
